import { cn } from '../../lib/utils';
import { TextButton } from './TextLink';

interface ReadErrorProps {
  /** What failed, as the user names it: "Couldn't load the balance". */
  message: string;
  onRetry: () => void;
  className?: string;
}

/**
 * A failed read, in the space its content would have taken, with a Retry.
 * One failed read degrades its own slot, never the page around it. A span, so
 * it sits in a meta line or a figure as readily as in a card body.
 */
export function ReadError({ message, onRetry, className }: ReadErrorProps) {
  return (
    <span role="alert" className={cn('inline-flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-text-muted', className)}>
      <span>{message}</span>
      <TextButton onClick={onRetry}>Retry</TextButton>
    </span>
  );
}
